import { gql } from "@apollo/client";

export default gql`
	mutation CancelPendingOrder($receipt: String!) {
		cancelPendingOrder(receipt: $receipt)
	}
`;
